import {
  Content,
  GroupField,
  KeyTextField,
  LinkField,
} from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import QuestionCard from './QuestionCard';
import { Button } from '@/components';
import styles from './QuestionCards.module.scss';
import { BlueCheckmarkIcon } from '@/assets/icons/PartnerPagesIcons';

interface Props {
  cards: GroupField<Simplify<Content.BenefitsSliceQuestionsPrimaryCardsItem>>;
  buttonText: KeyTextField;
  buttonLink: LinkField;
  labelText: KeyTextField;
}

const QuestionCards = ({ cards, buttonText, buttonLink, labelText }: Props) => {
  return (
    <ul className={styles.wrapper}>
      {cards.map((card) => (
        <QuestionCard key={card.card_title} card={card} />
      ))}
      <div className={styles.labelWrapper}>
        <Button
          text={buttonText}
          link={buttonLink}
          styles={styles.button}
          isArrow
        />
        <div className={styles.label}>
          <div className={styles.labelIcon}>
            <BlueCheckmarkIcon className={styles.labelIcon} />
          </div>
          <span>{labelText}</span>
        </div>
      </div>
    </ul>
  );
};

export default QuestionCards;
